import React from 'react';
import styled from '@emotion/styled';

const PresetsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const PresetButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: ${props => props.active ? '#f3f4f6' : 'white'};
  color: ${props => props.active ? '#374151' : '#6b7280'};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &:hover {
    background: ${props => props.active ? '#e5e7eb' : '#f9fafb'};
    border-color: ${props => props.active ? '#9ca3af' : '#9ca3af'};
  }
`;


const SearchPresets = ({ 
  presets = [], 
  activePreset, 
  onPresetChange 
}) => {
  return (
    <PresetsContainer>
      {presets.map((preset) => (
        <PresetButton
          key={preset.key}
          active={activePreset === preset.key}
          onClick={() => onPresetChange(preset.key)}
        >
          {preset.label}{preset.count !== undefined ? ` (${preset.count})` : ''}
        </PresetButton>
      ))}
    </PresetsContainer>
  );
};

export default SearchPresets;
